// extracted by mini-css-extract-plugin
export default {"spinner":"requests_spinner__PKBD9","rotateLoading":"requests_rotateLoading__j0mRL"};